import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { BookingItemConflict } from '../../models/booking-item-conflict';

@Injectable({
  providedIn: 'root'
})
export class BookingItemConflictService {
  private baseUrl = 'booking-item-conflict';

  constructor(private http: ApiClient) {}

  getConflicts(bookingItemId: number) {
    return this.http.get<BookingItemConflict[]>(
      `${this.baseUrl}/${bookingItemId}`
    );
  }

  getHireItemConflicts(hireItemId: number) {
    return this.http.get<BookingItemConflict[]>(
      `${this.baseUrl}/hire-item/${hireItemId}`
    );
  }
}
